var React = require('react');

function IcFileTypeVideo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Shape","d":"M19.446,38.892A19.446,19.446,0,1,1,38.893,19.446,19.468,19.468,0,0,1,19.446,38.892Zm0-37.272A17.826,17.826,0,1,0,37.272,19.446,17.846,17.846,0,0,0,19.446,1.62Z","transform":"translate(0 0)","key":0}),React.createElement("path",{"id":"Shape-2","data-name":"Shape","d":"M.831,16.376a.843.843,0,0,1-.4-.1A.818.818,0,0,1,0,15.558V.82A.815.815,0,0,1,.435.1a.837.837,0,0,1,.848.031L12.924,7.5a.811.811,0,0,1,0,1.377L1.282,16.246A.848.848,0,0,1,.831,16.376ZM1.664,2.319V14.057l9.272-5.869L1.664,2.319Z","transform":"translate(14.328 11.258)","key":1})]);
}

IcFileTypeVideo.defaultProps = {"id":"play-button","width":"38.893","height":"38.892","viewBox":"0 0 38.893 38.892"};

module.exports = IcFileTypeVideo;

IcFileTypeVideo.default = IcFileTypeVideo;
